import { Box, Typography } from "@mui/material";
import React from "react";
import VideoCard from "./VideoCard";

export default function Courses() {
  return (
    <Box
      sx={{
        mt: 4,
        // border: "1px solid gray",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          fontSize: "20px",
        }}
      >
        همه آموزش‌ها
      </Typography>
      <Box
        sx={{
          mt: 3,
          paddingX: "8px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <VideoCard />
        <VideoCard />
        <VideoCard />
        <VideoCard />
      </Box>
    </Box>
  );
}
